module.exports = __webpack_public_path__ + "static/media/userIconMessageBig.cdc4ea42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/userIconMessageBig.svg
// module id = 1816
// module chunks = 0